// /blog/technology/salesforce/page.js
// /blog/technology/javascript/page.js
import React, { useEffect } from "react";
import { Container, Header, Segment, Icon, List} from "semantic-ui-react";
import { Link } from "react-router-dom";
import Feed from "@components/Feed";
import "@styles/BlogBody.css";

const SalesforcePage = () => {
  // Add Open Graph meta tags for Salesforce category page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'Salesforce Articles - Cloud CZR | CRM Development & Automation';
    updateMetaTag('og:title', 'Salesforce Articles - Cloud CZR | CRM Development & Automation');
    updateMetaTag('og:description', 'Master Salesforce CRM with expert insights on Sales Cloud, Service Cloud, Marketing Cloud, triggers, and custom development techniques.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Master Salesforce CRM with expert insights on Sales Cloud, Service Cloud, Marketing Cloud, triggers, and custom development techniques.', false);
    updateMetaTag('twitter:title', 'Salesforce Articles - Cloud CZR | CRM Development & Automation', false);
    updateMetaTag('twitter:description', 'Master Salesforce CRM with expert insights on Sales Cloud, Service Cloud, Marketing Cloud, triggers, and custom development techniques.', false);
  }, []);

  const path = 'blog/technology/salesforce';
  return (



    <Container style={{ marginTop: "2em" }}>
      <Header as='h1' textAlign='center' icon style={{ color: '#a9885c', backgroundColor: '#702963' }}>
        <Icon name='cloud' style={{ color: '#a9885c' }}/>
        Salesforce Blog
        <Header.Subheader style={{ color: '#a9885c' }}>
        Salesforce is a leading CRM platform with powerful tools for managing customer relationships, automating processes, and building custom applications. Our Salesforce blog covers topics from foundational knowledge to advanced development techniques.
        </Header.Subheader>
      </Header>
      <Feed path={path} />
  </Container>
  );
};

export default SalesforcePage;
